module.exports = __webpack_public_path__ + "img/img-learning-hub.48406d58.svg";